import useApiHook from '../api/useApiHook';
import { useCallback } from 'react';


export const useGetCustomerEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getCustomerEnum = useCallback(async () => {
    const url = `/enums/customers`;
    await get(url);
  }, [get]);

  return { getCustomerEnum, data, error, loading };
};


export const useGetUsersEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getUsersEnum = useCallback(async () => {
    const url = `/enums/users`;
    await get(url);
  }, [get]);

  return { getUsersEnum, data, error, loading };
};

export const useGetContractsEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getContractsEnum = useCallback(async (id) => {
    const url = `/enums/customers/${id}/contracts`;
    await get(url);
  }, [get]);

  return { getContractsEnum, data, error, loading };
};

export const useGetProductEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getProductsEnum = useCallback(async (year, commodityId) => {
    const url = `/exchange-products?year=${year}&commodity=${commodityId}`;
    await get(url);
  }, [get]);

  return { getProductsEnum, data, error, loading };
};
